import React from "react";
import { Form } from "react-bootstrap";
import { TUseStepOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import UseStepSelector from "../../../UseStepSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TUseStepOption;
}

const ForecastUseStepsField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="dayStep">
      <Form.Label>Forecast time steps</Form.Label>

      <UseStepSelector
        spec={spec}
        values={formik.values.use_step}
        onChange={values => formik.setFieldValue('use_step', values)}
      />

      <FormError
        message={formik.errors.use_step as TFormErrorMessage}
        when={formik.touched.use_step && Boolean(formik.errors.use_step)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default ForecastUseStepsField
